module.exports = __webpack_public_path__ + "static/media/legendary.26324d6b.png";